import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@folio/stripes-components';
import styles from '../styles.css';

function SourceItem({
  sourceLabel,
  template,
  selectedTemplateId,
  setSelectedTemplate,
  index,
  setSourceUrl,
}) {
  const { id, name, icon, active } = template;

  const onClickhandler = () => {
    setSelectedTemplate(template);
    // setSourceUrl();
  };

  return (
    <div
      disabled={!active}
      className={
        id === selectedTemplateId ? styles.selectedButton : styles.button
      }
      id={`add-new-instance-${name}-btn`}
      key={template.id}
      role="button"
      onClick={() => onClickhandler()}
      onKeyDown={() => onClickhandler()}
      tabIndex={index}
    >
      <Icon icon={icon || 'document'} size="large">
        {sourceLabel}
      </Icon>
    </div>
  );
}

SourceItem.propTypes = {
  template: PropTypes.object,
  selectedTemplateId: PropTypes.string,
  setSelectedTemplate: PropTypes.func,
  index: PropTypes.number,
  sourceLabel: PropTypes.string,
  setSourceUrl: PropTypes.func,
};

export default SourceItem;
